import React, { FC } from 'react';
import { Dialog, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AddCategoryForm from './add-category-form-component';

type AddCategoryDialogProps = {
    dialogOpen: boolean;
    onCloseDialog: () => void;
    onAddCategory: (category: { _id: string; name: string }) => void;
};
const AddCategoryDialog: FC<AddCategoryDialogProps> = ({
    dialogOpen,
    onCloseDialog,
    onAddCategory,
}: AddCategoryDialogProps) => {
    const { t: translate } = useTranslation('actions-materials');
    return (
        <Dialog fullWidth maxWidth="sm" open={dialogOpen}>
            <DialogTitle>{translate('actions-materials:ADD_CATEGORY')}</DialogTitle>
            <AddCategoryForm onCloseDialog={onCloseDialog} onAddCategory={onAddCategory} />
        </Dialog>
    );
};

export default AddCategoryDialog;
